import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, Tc } from '../../../core/_infrastructure/types/common';
import { RegExportadorItemResultsViewModel, FilterSearchingRegExportadorViewModel, RegExportadorItemViewModel } from './exportador.types';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExportadorService } from './exportador.service';

@Component({
    selector: 'app-exportador-list',
    templateUrl: './exportador-list.component.html',
})
export class ExportadorListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultExportador: RegExportadorItemResultsViewModel;
    listPais: Tc[] = [];
    listProvincia: Tc[] = [];
    listMunicipio: Tc[] = [];
    cols: any[];
    visibilitySpinner: boolean = false;
    public isCollapsed = false;
    paisEspania: number = 0;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private exportadorService: ExportadorService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincia = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'NIF', header: 'NIF/EORI' },
            { field: 'RazonSocial', header: 'Nombre o Razón Social' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'IdProvinciaDescripcion', header: 'Provincia' },
            { field: 'IdMunicipioDescripcion', header: 'Municipio' },
            { field: 'CodigoZip', header: 'Código Postal' },
            { field: 'Activo', header: 'Activo' },
            { field: 'FechaAlta', header: 'Fecha Alta' },
            { field: 'FechaBaja', header: 'Fecha Baja' },
            { field: 'FechaCaducidadBaja', header: 'Fecha Caducidad Baja' },
            { field: 'FechaUltimaExportacion', header: 'Fecha Última Exportación' },
        ];

        this.form = this.fb.group({
            NIF: ['', CustomValidator.NIFValidator],
            RazonSocial: '',
            Direccion: '',
            IdPais: null,
            IdProvincia: null,
            IdMunicipio: null,
            CodigoZip: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]{5}$')])],
            Activo: EnumSiNoTodos.TODOS,
            FechaAlta: null,
            FechaBaja: null,
            FechaCaducidadBaja: null,
            FechaUltimaExportacion: null,
        });

        let config = this.getConfig();
        this.paisEspania = parseInt(config.IdPaisEspania);

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        let hayFiltros: boolean = false;

        if (this.exportadorService.currentFilter.IdPais != null) {
            hayFiltros = true;

            this.form.patchValue({
                IdPais: this.exportadorService.currentFilter.IdPais,
            });

            this.onSelectPais();

            if (this.exportadorService.currentFilter.IdProvincia != null && this.paisEspania) {
                this.form.patchValue({
                    IdProvincia: this.exportadorService.currentFilter.IdProvincia,
                });

                this.onSelectProvincia();

                this.form.patchValue({
                    IdMunicipio: this.exportadorService.currentFilter.IdMunicipio,
                });
            }
        }

        if (
            this.exportadorService.currentFilter.NIF != '' ||
            this.exportadorService.currentFilter.RazonSocial != '' ||
            this.exportadorService.currentFilter.Direccion != '' ||
            this.exportadorService.currentFilter.CodigoZip != '' ||
            this.exportadorService.currentFilter.Activo != EnumSiNoTodos.TODOS ||
            this.exportadorService.currentFilter.FechaAlta != null ||
            this.exportadorService.currentFilter.FechaBaja != null ||
            this.exportadorService.currentFilter.FechaCaducidadBaja != null ||
            this.exportadorService.currentFilter.FechaUltimaExportacion != null
        ) {
            hayFiltros = true;

            this.form.patchValue({
                NIF: this.exportadorService.currentFilter.NIF,
                RazonSocial: this.exportadorService.currentFilter.RazonSocial,
                Direccion: this.exportadorService.currentFilter.Direccion,
                CodigoZip: this.exportadorService.currentFilter.CodigoZip,
                Activo: this.exportadorService.currentFilter.Activo,
                FechaAlta: this.exportadorService.currentFilter.FechaAlta,
                FechaBaja: this.exportadorService.currentFilter.FechaBaja,
                FechaCaducidadBaja: this.exportadorService.currentFilter.FechaCaducidadBaja,
                FechaUltimaExportacion: this.exportadorService.currentFilter.FechaUltimaExportacion,
            });

            if (hayFiltros) this.onSearchButton();
        }
    }

    onSelectPais() {
        if (this.form.value.IdPais == this.paisEspania) {
            this.listProvincia = [];
            this.globalService.getProvincias().subscribe(res => {
                this.listProvincia = res;
            });
        } else {
            this.listProvincia = [];
            this.listMunicipio = [];
        }

        this.form.patchValue({
            IdProvincia: null,
            IdMunicipio: null,
        });
    }

    onSelectProvincia() {
        const idProvincia = this.form.value.IdProvincia;

        this.listMunicipio = [];
        this.globalService.getMunicipios(idProvincia).subscribe(res => {
            this.listMunicipio = res;
        });

        this.form.patchValue({
            IdMunicipio: null,
        });
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.exportadorService.currentFilter.NIF = this.form.value.NIF;
        this.exportadorService.currentFilter.RazonSocial = this.form.value.RazonSocial;
        this.exportadorService.currentFilter.Direccion = this.form.value.Direccion;
        this.exportadorService.currentFilter.IdPais = this.form.value.IdPais;
        this.exportadorService.currentFilter.IdProvincia = this.form.value.IdProvincia;
        this.exportadorService.currentFilter.IdMunicipio = this.form.value.IdMunicipio;
        this.exportadorService.currentFilter.CodigoZip = this.form.value.CodigoZip;
        this.exportadorService.currentFilter.Activo = this.form.value.Activo;
        this.exportadorService.currentFilter.FechaAlta = this.form.value.FechaAlta;
        this.exportadorService.currentFilter.FechaBaja = this.form.value.FechaBaja;
        this.exportadorService.currentFilter.FechaCaducidadBaja = this.form.value.FechaCaducidadBaja;
        this.exportadorService.currentFilter.FechaUltimaExportacion = this.form.value.FechaUltimaExportacion;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = 'RazonSocial') {
        this.loading = true;

        let model: FilterSearchingRegExportadorViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        this.exportadorService.postGetPagedByFilter(model).subscribe(res => {
            this.resultExportador = res;

            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            NIF: '',
            RazonSocial: '',
            Direccion: '',
            IdPais: null,
            IdProvincia: null,
            IdMunicipio: null,
            CodigoZip: '',
            Activo: EnumSiNoTodos.TODOS,
            FechaAlta: null,
            FechaBaja: null,
            FechaCaducidadBaja: null,
            FechaUltimaExportacion: null,
        });

        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultExportador = new RegExportadorItemResultsViewModel();
    }

    CreateModel() {
        let model: FilterSearchingRegExportadorViewModel = new FilterSearchingRegExportadorViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/registros/exportadores/create']);
    }

    onEdit(item: RegExportadorItemViewModel) {
        this.router.navigate(['/mantenimiento/registros/exportadores/edit', item.Id]);
    }

    onDelete(item: RegExportadorItemViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.exportadorService.deleteExportador(item.Id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Exportador eliminado correctamente');
                        this.onSearchButton();
                    },
                    error: () =>
                        this.addErrorMessage('Error al borrar el Exportador. Puede que no se pueda eliminar porque ha sido utilizado en alguna solicitud.'),
                });
            },
        });
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.exportadorService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }
}
